import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getSpaceStyle } from '../patterns/space.mjs';
import { styled } from './factory.mjs';

export const Space = /* @__PURE__ */ forwardRef(function Space(props, ref) {
  const [patternProps, restProps] = splitProps(props, ["size","isHalf"])

const styleProps = getSpaceStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })